import { BaseTool } from './BaseTool';
import { ToolType } from '../types';

export class EyedropperTool extends BaseTool {
  public id: ToolType = 'eyedropper';
  public name = 'Eyedropper Color Picker';
  public cursor = 'crosshair';

  public onMouseDown(_e: MouseEvent, canvasX: number, canvasY: number): void {
    const color = this.sampleColor(canvasX, canvasY);
    if (color) {
      this.editor.setForegroundColor(color);
      this.editor.showToast(`Sampled color: ${color}`);
    }
  }

  private sampleColor(canvasX: number, canvasY: number): string | null {
    const x = Math.floor(canvasX);
    const y = Math.floor(canvasY);
    if (x < 0 || x >= this.editor.width || y < 0 || y >= this.editor.height) {
      return null;
    }

    // Sample from composite canvas
    const ctx = this.editor.mainCtx;
    const pixel = ctx.getImageData(x, y, 1, 1).data;
    const toHex = (n: number) => n.toString(16).padStart(2, '0');
    return `#${toHex(pixel[0])}${toHex(pixel[1])}${toHex(pixel[2])}`;
  }
}
